import utils from '@/common/utils'
import dayjs from 'dayjs'

const state = {
  range_start_time: '',
  range_end_time: '',
  select_month: localStorage.getItem('select_month') || dayjs().startOf('month').format('YYYY-MM-DD')
}

const getters = {
  getRangeTime: state => [state.range_start_time, state.range_end_time],
  getSelectMonth: state => state.select_month
}

const mutations = {
  set_range_time (state, selectMonth) {
    state.range_start_time = utils.MCTime2Time(dayjs(selectMonth)).format('YYYY-MM-DD HH:mm:ss')
    state.range_end_time = utils.MCTime2Time(dayjs(selectMonth).endOf('month')).format('YYYY-MM-DD HH:mm:ss')
    localStorage.setItem('select_month', dayjs(selectMonth).format('YYYY-MM-DD'))
  },
  delete_range_time () {
    state.range_start_time = ''
    state.range_end_time = ''
    localStorage.removeItem('select_month')
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js